// extracted by mini-css-extract-plugin
module.exports = {"button":"Theme_button__2qhyp","button-light":"Theme_button-light__20_9T"};